import { createContext, useContext } from 'react';
import { createLiffProvider } from './create-liff-provider.js';
export const createLiffContext = () => {
    const context = createContext({
        isLoggedIn: false,
        isReady: false,
        liff: {},
    });
    context.displayName = 'LiffContext';
    return {
        LiffConsumer: context.Consumer,
        LiffProvider: createLiffProvider(context),
        useLiff: () => useContext(context),
    };
};
